import { render, staticRenderFns } from "./ManageView.vue?vue&type=template&id=c88d66b0"
import script from "./ManageView.vue?vue&type=script&lang=js"
export * from "./ManageView.vue?vue&type=script&lang=js"
import style0 from "./ManageView.vue?vue&type=style&index=0&id=c88d66b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports